import {
  DRIVE_REPLACE_DOCUMENT,
  DRIVE_FETCH_CURRENT_DIRECTORY_SUCCESS,
  DRIVE_INITIALIZE,
  DRIVE_SET_CURRENT_DIRECTORY,
  DRIVE_ADD_TO_CURRENT_DIRECTORY,
  DRIVE_SELECT_DOCUMENTS,
  DRIVE_REMOVE_DOCUMENT_FROM_STORE_BY_ID, 
  DRIVE_SET_USED_PERCENTAGE, 
  DRIVE_SET_ENTIDADES,
  DRIVE_SET_GB_CONTRATADOS,
} from '../actions/constants/drive.contants';
import canBeDisplayed from '../../helpers/image.helper';

const initialState = {
  currentDirectory: {
    tipoEntidad: {
      id: null,
      name: null,
    },
    entidadId: null,
    name: null,
    files: [],
    selected: {
      files: [],
      keys: [],
    },
    totalNumberOfFiles: null,
    tiendaId: null,
  },
  modoVisualizacion: 'tabla',
  documentToUpload: {
    name: null,
    description: null,
    file: null,
    uploading: false,
  },
  entidades: [],
  porcentajeTotalUso: 0,
  totalGBContratado: null,
};

export default function driveReducer(state = initialState, { type, payload }) {
  switch (type) {
    case DRIVE_INITIALIZE: {
      const { entidades } = state;
      return {
        ...initialState,
        entidades,
      };
    }
    case DRIVE_SET_CURRENT_DIRECTORY: {
      const { entidadTipoId, entidadId, tiendaId } = payload;
      const { currentDirectory } = state;
      return {
        ...state,
        currentDirectory: {
          ...currentDirectory,
          tipoEntidad: {
            id: entidadTipoId,
            name: null,
          },
          entidadId,
          tiendaId,
        },
      };
    }
    case DRIVE_ADD_TO_CURRENT_DIRECTORY: {
      const { currentDirectory, currentDirectory: { files, totalNumberOfFiles } } = state;
      const { file } = payload;
      const { mimeType } = file;
      const esImagen = canBeDisplayed(mimeType);
      const mutatedFile = {
        ...file,
        esImagen,
      };
      return {
        ...state,
        currentDirectory: {
          ...currentDirectory,
          files: [mutatedFile, ...files],
          totalNumberOfFiles: (totalNumberOfFiles + 1),
        },
      };
    }
    case DRIVE_FETCH_CURRENT_DIRECTORY_SUCCESS: {
      const { files, total } = payload;
      const { currentDirectory } = state;

      const mutatedFiles = files.map((file) => {
        const { mimeType } = file;
        const esImagen = canBeDisplayed(mimeType);
        return {
          ...file,
          esImagen,
        };
      });

      return {
        ...state,
        currentDirectory: {
          ...currentDirectory,
          files: mutatedFiles,
          totalNumberOfFiles: total,
        },
      };
    }
    case DRIVE_REPLACE_DOCUMENT: {
      const { currentDirectory } = state;
      const { documento, documento: { id }, id: documentoId } = payload;
      const { files } = currentDirectory;
      const searchId = (documentoId) || id;
      const { mimeType } = documento;
      const esImagen = canBeDisplayed(mimeType);
      const mutatedFile = {
        ...documento,
        esImagen,
      };
      const index = files.findIndex(item => item.id === searchId);
      files.splice(index, 1, mutatedFile);

      return {
        ...state,
        currentDirectory: {
          ...currentDirectory,
          files,
        },
      };
    }
    case DRIVE_SELECT_DOCUMENTS: {
      const { documentos, selectedRowKeys } = payload;
      const { currentDirectory } = state;
      return {
        ...state,
        currentDirectory: {
          ...currentDirectory,
          selected: {
            files: documentos,
            keys: selectedRowKeys,
          },
        },
      };
    }
    case DRIVE_REMOVE_DOCUMENT_FROM_STORE_BY_ID: {
      const { id } = payload;
      const { currentDirectory, currentDirectory: { files } } = state;
      const index = files.findIndex(item => item.id === id);
      files.splice(index, 1);

      return {
        ...state,
        currentDirectory: {
          ...currentDirectory,
          files,
        },
      };
    }
    case DRIVE_SET_USED_PERCENTAGE: {
      const { porcentaje } = payload;
      return {
        ...state,
        porcentajeTotalUso: porcentaje,
      };
    }
    case DRIVE_SET_ENTIDADES: {
      const { entidades } = payload;
      return {
        ...state,
        entidades,
      };
    }
    case DRIVE_SET_GB_CONTRATADOS: {
      const { total } = payload;
      return {
        ...state,
        totalGBContratado: total,
      };
    }
    default:
      return state;
  }
}
